import type { ResponsiveMarketingFont } from '@shared/utils/fonts/marketingFonts';
import type { StyleSystemProps } from '@withjoy/joykit';
import { Box, Flex, styled } from '@withjoy/joykit';

export const CardGradient = styled(Box)`
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  rect {
    pointer-events: none;
  }
`;

export const CardSafeContentArea = styled(Box)``;
export const CardContent = styled(Flex)``;
export const CardDek = styled(Box)``;
export const CardHed = styled(Box)``;
export const CardEyebrow = styled(Box)``;
export const CardCta = styled(Box)``;
export const CardBlockText = styled(Flex)``;
export const CardGrid = styled(Box)``;

const contentStyles: StyleSystemProps = {
  alignItems: 'center',
  flexDirection: 'column',
  textAlign: 'center',
};

const gradientStyles: StyleSystemProps = {
  backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0) 25.52%, rgba(0, 0, 0, 0.4) 80.21%), linear-gradient(180deg,
                      rgba(0, 0, 0, 0) 43.75%, rgba(1, 1, 1, 0.6525) 86.98%, rgba(0, 0, 0, 0.87) 100%),
                      url(9e9bb472-033f-58f6-a392-cafddc92a523)`,
  boxShadow: `0px 10px 60px -20px rgba(44, 41, 37, 0.03), 0px 9px 36px -30px rgba(0, 0, 0, 0.04)`,
  filter: `drop-shadow(0px 3px 8px rgba(0, 0, 0, 0.03))`,
};

const blockTextStyles: StyleSystemProps = {
  alignItems: 'center',
  flexDirection: 'column',
};

const eyebrowStyles: StyleSystemProps = {
  typeVariant: ['hed1', null, 'hed4'],
  fontWeight: 700,
  maxWidth: '100%',
  marginBottom: 3,
};
const hedStyles: StyleSystemProps & ResponsiveMarketingFont = {
  typeVariant: ['HedMobile32', null, 'Hed40'],
  maxWidth: '100%',
  fontSize: ['24px', null],
  fontWeight: [300, null],
};
const dekStyles: StyleSystemProps & ResponsiveMarketingFont = {
  typeVariant: [null, null, 'Dek20', null, 'Dek24'],
  maxWidth: '100%',
  width: ['100%', null, '552px', '648px'],
};

const safeContentAreaStyles: StyleSystemProps = {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column-reverse',
  paddingBottom: [6, null, 8],
  paddingX: 7,
  position: 'relative',
};

const ctaStyles: StyleSystemProps = {
  borderRadius: '112px',
  paddingY: 4,
  paddingX: 7,
  marginTop: 7,
  typeVariant: 'hed2',
  display: ['none', null, 'block'],
};

const gridStyles: StyleSystemProps = {
  display: 'grid',
  gridColumnGap: ['12px', null, '40px'],
  gridRowGap: ['24px', null, '64px'],
  gridTemplateColumns: ['1fr', null, 'repeat(2, 1fr)', null, 'repeat(3, 1fr)'],
};

export const styles = {
  safeContentArea: safeContentAreaStyles,
  content: contentStyles,
  gradient: gradientStyles,
  blockText: blockTextStyles,
  eyebrow: eyebrowStyles,
  hed: hedStyles,
  dek: dekStyles,
  cta: ctaStyles,
  grid: gridStyles,
};
